const platformSupportDefinitions = {
  shopify: {
    displayName: 'Shopify',
    documentationLink: 'https://support.shipbob.com/en/articles/6106046-shopify-initial-setup',
    supportLink: 'https://support.shipbob.com/en/articles/3944348-how-do-i-get-in-touch-with-shipbob-s-merchant-care-team',
    inventoryLink: 'https://support.shipbob.com/en/articles/4388326-shopify-inventory-quantities-sync'
  }
}

export default platformSupportDefinitions
